import { createContext, useState, useEffect, useCallback } from "react";
import * as SalespersonHelper from "helpers/SalespersonHelper";

import SalesPersonService from "services/SalespersonService";
import toast from "react-hot-toast";

const SalesPersonContext = createContext();

export const SalesPersonProvider = ({ children }) => {
  const [salesPersons, setSalesPersons] = useState([]);
  const [currentSalesperson, setCurrentSalespersonState] = useState(() => {
    return SalespersonHelper.getCurrentSalesperson();
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function loadFromStorage() {
      const list = await SalespersonHelper.getSalespersons();
      setSalesPersons(list || []);
      const current = SalespersonHelper.getCurrentSalesperson();
      setCurrentSalespersonState(current);
    }
    loadFromStorage();
  }, []);

  const setCurrentSalesperson = useCallback((salesperson) => {
    SalespersonHelper.setCurrentSalesperson(salesperson);
    setCurrentSalespersonState(salesperson);
  }, []);

  const clearSalespersonSession = useCallback(() => {
    SalespersonHelper.clearSalespersonSession();
    setCurrentSalespersonState(null);
  }, []);

  const loadSalesPersons = useCallback(async () => {
    try {
      setIsLoading(true);

      const resp = await SalesPersonService.getSalesPersons();

      const list = Array.isArray(resp)
        ? resp
        : Array.isArray(resp?.data)
          ? resp.data
          : Array.isArray(resp?.data?.data)
            ? resp.data.data
            : [];

      const savedList = await SalespersonHelper.saveSalespersons(list);
      setSalesPersons(savedList);
      return savedList;
    } catch (err) {
      toast.error("Failed to load salespersons");
      console.error("SalesPerson load error", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const findSalesPersonByPassword = async (password) => {
    if (salesPersons.length > 0) {
      return salesPersons.find((p) => String(p.password) === String(password)) || null;
    }

    const list = await SalespersonHelper.getSalespersons();
    return list.find((p) => String(p.password) === String(password)) || null;
  };

  return (
    <SalesPersonContext.Provider
      value={{
        salesPersons,
        setSalesPersons,
        currentSalesperson,
        setCurrentSalesperson,
        clearSalespersonSession,
        findSalesPersonByPassword,
        loadSalesPersons,
        isLoading,
      }}
    >
      {children}
    </SalesPersonContext.Provider>
  );
};

export default SalesPersonContext;
